
export const dateFormatterDE = (date) => {
    if (date != null) {
        const dateArray = date.split("-");
        return dateArray[2] + "." + dateArray[1] + "." + dateArray[0];
    }
    return null;
} 